import { render, staticRenderFns } from "./RecoveryCode.vue?vue&type=template&id=4ca69628&scoped=true"
import script from "./RecoveryCode.vue?vue&type=script&lang=js"
export * from "./RecoveryCode.vue?vue&type=script&lang=js"
import style0 from "./RecoveryCode.vue?vue&type=style&index=0&id=4ca69628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca69628",
  null
  
)

export default component.exports